var _path, _ellipse, _ellipse2, _ellipse3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnordered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54688 12.4029C5.54688 12.2217 5.61837 12.048 5.74563 11.9199C5.87288 11.7917 6.04548 11.7198 6.22545 11.7198H18.4399C18.6199 11.7198 18.7924 11.7917 18.9197 11.9199C19.047 12.048 19.1185 12.2217 19.1185 12.4029C19.1185 12.5841 19.047 12.7578 18.9197 12.8859C18.7924 13.014 18.6199 13.086 18.4399 13.086H6.22545C6.04548 13.086 5.87288 13.014 5.74563 12.8859C5.61837 12.7578 5.54688 12.5841 5.54688 12.4029ZM5.54688 6.93802C5.54688 6.75684 5.61837 6.58309 5.74563 6.45499C5.87288 6.32688 6.04548 6.25491 6.22545 6.25491H18.4399C18.6199 6.25491 18.7924 6.32688 18.9197 6.45499C19.047 6.58309 19.1185 6.75684 19.1185 6.93802C19.1185 7.11919 19.047 7.29294 18.9197 7.42105C18.7924 7.54915 18.6199 7.62112 18.4399 7.62112H6.22545C6.04548 7.62112 5.87288 7.54915 5.74563 7.42105C5.61837 7.29294 5.54688 7.11919 5.54688 6.93802ZM5.54688 1.47315C5.54688 1.29198 5.61837 1.11822 5.74563 0.990117C5.87288 0.862009 6.04548 0.790039 6.22545 0.790039H18.4399C18.6199 0.790039 18.7924 0.862009 18.9197 0.990117C19.047 1.11822 19.1185 1.29198 19.1185 1.47315C19.1185 1.65432 19.047 1.82807 18.9197 1.95618C18.7924 2.08429 18.6199 2.15626 18.4399 2.15626H6.22545C6.04548 2.15626 5.87288 2.08429 5.74563 1.95618C5.61837 1.82807 5.54688 1.65432 5.54688 1.47315Z",
    fill: "#757575"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.97148,
    cy: 1.86667,
    rx: 1.85429,
    ry: 1.86667,
    fill: "#757575"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.97148,
    cy: 6.53366,
    rx: 1.85429,
    ry: 1.86667,
    fill: "#757575"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.97148,
    cy: 12.1333,
    rx: 1.85429,
    ry: 1.86667,
    fill: "#757575"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnordered);
export default __webpack_public_path__ + "static/media/unordered.b51943a2.svg";
export { ForwardRef as ReactComponent };